import React, { useState } from 'react';
import { Text, FormControl, FormLabel, Input, CircularProgress } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { Button } from '../';
import { interpreterLogin } from '../../redux/reducers';

const LoginForm = ({ history, setToken }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  // TODO: remove these
  const [email, setEmail] = useState(process.env.REACT_APP_DEV_USERNAME || '');
  const [password, setPassword] = useState(process.env.REACT_APP_DEV_PASSWORD || '');
  const { signingIn, signInError } = useSelector((state) => state.user);

  const doLogin = (email, password) => {
    dispatch(interpreterLogin(email, password)).then((result) => {
      if (result != null) {
        const { tokenData } = result;
        const { access_token, refresh_token, expiryTime } = tokenData;

        // TODO: check if there is better way. local storage is vulnerable to XSS
        // store token so that login is not always needed when page is refreshed
        setToken({
          access_token,
          refresh_token,
          expiryTimeStr: moment(expiryTime).toISOString(),
        });

        // open
        history.push('/interpreter');
      }
    });
  };

  return (
    <>
      <FormControl mt={16} id="email" isRequired>
        <FormLabel color="white">{t('login.email')}</FormLabel>
        <Input
          color="white"
          variant="flushed"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </FormControl>

      <FormControl mt={4} id="password" isRequired>
        <FormLabel color="white">{t('login.password')}</FormLabel>
        <Input
          color="white"
          variant="flushed"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </FormControl>

      <Button
        mt={16}
        color="white"
        borderWidth={2}
        borderColor="white"
        backgroundColor="brand.50"
        disabled={email.length === 0 || password.length === 0}
        onClick={() => doLogin(email, password)}
      >
        {signingIn === false && t('login.signIn')}
        {signingIn === true && <CircularProgress isIndeterminate color="white" size={8} />}
      </Button>
      {signInError != null && signingIn === false && (
        <Text mt={2} color="white">
          {t('login.invalidUserNameOrPassword')}
        </Text>
      )}
    </>
  );
};

LoginForm.propTypes = {
  history: PropTypes.any,
  setToken: PropTypes.any,
};

export default withRouter(LoginForm);
